export class AppError {
    constructor(public originalError?: any) { }
  
    Message: string;
}
